import styled from 'styled-components';
import { Label } from '@trevor/ui-components';
import { Modal } from '@/features/modals/components';

export const VariablesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 0.5fr;
  column-gap: var(--spacing-l);
  row-gap: var(--spacing-l);
  align-items: start;

  > button:last-of-type {
    width: 100%;
  }
`;

export const RedirectLabel = styled.span`
  color: var(--color-feedback-error-darker);
`;

export const LearnMoreLabel = styled.a`
  color: var(--color-interface-secondary-normal);
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
`;

export const BannerLink = styled.a`
  color: inherit;
  font-weight: bold;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: inherit;
  }
`;

export const ConfigureEmbedModalContainer = styled(Modal)`
  gap: var(--spacing-xl);
  padding: 48px;
  width: 624px;
`;

export const RedirectUrlContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing-xxs) * 2);
`;

export const VariableLabel = styled(Label).attrs({
  variant: 1,
})`
  margin-top: var(--spacing-m);
`;
